export enum OnboardingStatus {
    STORE_ADDITION = 'STORE_ADDITION',
    PLAN_ADDITION = 'PLAN_ADDITION',
    BRAND_ADDITION = 'BRAND_ADDITION',
    ERROR="ERROR"
  }